import { render, staticRenderFns } from "./operashareTemplateWindow.vue?vue&type=template&id=68b4b13a"
import script from "./operashareTemplateWindow.vue?vue&type=script&lang=js"
export * from "./operashareTemplateWindow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports